import React from 'react'
import CustomDialog from '../../../Product/components/organisms/Dialog'

import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useState } from 'react'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { useContext } from 'react'
import schedulePickupContext from '../../../Product/context/plugin/schedulePickup/schedulePickupContext'
import { useEffect } from 'react'
import { mapData, currencyFormat } from '../../../Product/common/components'
import authContext from '../../../Product/context/auth/authContext'
import Popup from '../../../Product/components/organisms/Popup'
import StripeCardContext from '../../../Product/context/stripe/card/cardContext'
import DirectStripeContext from '../../../Product/context/directStripe/directStripeContext'
import PluginContext from '../../../Product/context/plugin/pluginContext'
import BuyerContext from '../../../Product/context/buyer/buyerContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import moment from 'moment'
const MultiCheckIn = ({
    pickupData,
    trigger,
    setTrigger,
    curbside,
    extendInvoices,
    search,
    addBusinessDaysInvoice,
    isHeader,
}) => {
    const [checkInStep, setCheckInStep] = useState(0)
    const [checkInModal, setCheckInModal] = useState(false)
    const [exist, setExist] = useState(pickupData?.type ? true : false)
    const [loading, setLoading] = useState()
    const { addCheckIn, responseStatus } = useContext(schedulePickupContext)
    const { user } = useContext(authContext)
    const [openPickupExtension, setOpenPickupExtension] = useState(false)
    const [allData, setAllData] = useState([])
    const [cardData, setCardData] = useState('nocard')
    const [paymentLoading, setPaymentLoading] = useState(false)
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: cardResponseStatus,
        clearResponse: cardClearResponse,
    } = useContext(StripeCardContext)
    const { usercards } = useContext(DirectStripeContext)
    const pluginContext = useContext(PluginContext)
    const buyerContext = useContext(BuyerContext)
    const { responseStatus: pluginResponseStatus, extendPickupPayment } = pluginContext
    const { getAllBuyerProducts, buyer_allproducts } = buyerContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const checkInValidationSchema = Yup.object().shape({
        parking_lot_no: Yup.string().when('type', {
            is: '2' || 2,
            then: Yup.string()
                .trim()
                .matches(/^[a-zA-Z0-9]*$/g, 'Special characters are not allowed')
                .max(20, '20 characters max')
                .required('Required'),
        }),
        car_make: Yup.string().when('type', {
            is: '2' || 2,
            then: Yup.string()
                .trim()
                .matches(/^[a-zA-Z0-9]*$/g, 'Special characters are not allowed')
                .max(20, '20 characters max')
                .required('Required'),
        }),
        model: Yup.string().when('type', {
            is: '2' || 2,
            then: Yup.string()
                .trim()
                .matches(/^[a-zA-Z0-9]*$/g, 'Special characters are not allowed')
                .max(20, '20 characters max')
                .required('Required'),
        }),
        color: Yup.string().when('type', {
            is: '2' || 2,
            then: Yup.string()
                .trim()
                .matches(/^[a-zA-Z]*$/g, 'Special characters are not allowed')
                .max(20, '20 characters max')
                .required('Required'),
        }),
    })

    const formikCheckIn = useFormik({
        initialValues: {
            type: pickupData?.type || 1,
            parking_lot_no: pickupData?.parking_lot_no,
            car_make: pickupData?.car_make,
            model: pickupData?.model,
            color: pickupData?.color,
            schedule_id: pickupData?.id?.join(','),
        },
        validationSchema: checkInValidationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            setLoading(true)
            addCheckIn({ ...values, site_id: global?.storeDetails?.site_id, user_id: user?.id })
        },
    })
    const checkInInfo = [
        {
            title: '',
            type: 'radio',
            class: 'col-12',
            int: 1,
            item: [
                { id: 1, description: "I'm At The Warehouse" },
                { id: 2, description: 'Parking Lot' },
            ],
            name: 'type',
            formik: formikCheckIn,
        },
        {
            label: 'Parking Lot No',
            name: 'parking_lot_no',
            type: 'select',
            placeholder: 'Parking Lot No',
            class: formikCheckIn.values.type == 1 ? 'd-none' : 'col-6',
            options: curbside?.map((val, i) => ({
                show: val.name,
                value: val.name,
                index: i,
            })),
            formik: formikCheckIn,
        },
        {
            label: 'Car Make',
            name: 'car_make',
            type: 'text',
            placeholder: 'Car Make',
            class: formikCheckIn.values.type == 1 ? 'd-none' : 'col-6',
            formik: formikCheckIn,
        },
        {
            label: 'Model',
            name: 'model',
            type: 'text',
            placeholder: 'Model',
            class: formikCheckIn.values.type == 1 ? 'd-none' : 'col-6',
            formik: formikCheckIn,
        },
        {
            label: 'Color',
            name: 'color',
            type: 'text',
            placeholder: 'Color',
            class: formikCheckIn.values.type == 1 ? 'd-none' : 'col-6',
            formik: formikCheckIn,
        },
    ]

    const manageCheckInModal = () => {
        setCheckInModal(!checkInModal)
        setCheckInStep(0)
        formikCheckIn.resetForm()
        formikCheckIn.setTouched({})
    }

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'addCheckIn') {
                setLoading(false)
                if (responseStatus.status === 'success') {
                    setCheckInStep(1)
                }
            }
        }
    }, [responseStatus])
    useEffect(() => {
        setExist(pickupData?.type ? true : false)
        formikCheckIn.setValues({
            type: pickupData?.type,
            parking_lot_no: pickupData?.parking_lot_no,
            car_make: pickupData?.car_make,
            model: pickupData?.model,
            color: pickupData?.color,
            schedule_id: pickupData?.id,
        })
    }, [pickupData])
    useEffect(() => {
        if (formikCheckIn.values.type == 1) {
            formikCheckIn.setFieldValue('parking_lot_no', '')
        }
    }, [formikCheckIn.values.type])

    useEffect(() => {
        if (global?.pluginConfiguration?.extended_pickup?.enable == 1 && get_all_card_details) {
            setAllData(get_all_card_details.records)
        }
    }, [get_all_card_details])
    useEffect(() => {
        if (global?.pluginConfiguration?.extended_pickup?.enable == 1 && usercards.length) {
            setAllData(usercards)
        }
    }, [usercards])

    const onChangeCard = (e) => {
        e.target.checked ? setCardData(e.target.value) : setCardData('nocard')
    }
    const handleExtendedPickupPayment = async () => {
        if (cardData == 'nocard') {
            setAlert('Please Choose a card!', 'error')
            setPaymentLoading(false)
        } else {
            setPaymentLoading(true)
            const getExtendedDate = (inv) => {
                const ext_date = buyer_allproducts.results.filter(
                    (item) => item.common_invoice == inv,
                )
                const ext_date2 = addBusinessDaysInvoice(
                    ext_date[0]?.schedule_location_id,
                    ext_date[0]?.sche_localpick_local,
                    Number(
                        global?.storeConfigration?.abandoned_schedule_hours?.value
                            ? global?.storeConfigration?.abandoned_schedule_hours?.value
                            : 0,
                    ) +
                        Number(global?.pluginConfiguration?.extended_pickup?.service_key) +
                        Number(user?.extended_pickup == 1 ? 5 : 0),
                )
                return ext_date2
            }
            const paymentBody = {
                invoice_id: extendInvoices.map((inv) => {
                    return {
                        id: inv,
                        amount: global?.pluginConfiguration?.extended_pickup?.access_key,
                        extended_date: moment.utc(getExtendedDate(inv)),
                    }
                }),

                payment_details: {
                    source: cardData,
                    account_id: process.env.REACT_APP_AUCTIONPAYID,
                    customer: user.card_paymentid,
                    currency: 'usd',
                    description: 'Extended Pickup checkout',
                },
                amount: parseFloat(
                    parseFloat(extendInvoices.length) *
                        parseFloat(global?.pluginConfiguration?.extended_pickup?.access_key),
                ).toFixed(2),
                site_id: global?.storeDetails?.site_id,
                user_id: user.id,
                days: global?.pluginConfiguration?.extended_pickup?.service_key,
            }
            await extendPickupPayment(paymentBody)
        }
    }

    useEffect(() => {
        if (pluginResponseStatus?.from == 'extendedPickup' && isHeader) {
            if (pluginResponseStatus.status == 'success') {
                setPaymentLoading(false)
                setOpenPickupExtension(false)
                getAllBuyerProducts(search)
                setAlert('Your Pickup Has Been Extended!', 'success')
            } else {
                setPaymentLoading(false)
                setOpenPickupExtension(false)
                setAlert('Something Went Wrong!', 'error')
            }
        }
    }, [pluginResponseStatus])

    return (
        <>
            <div className="checkINPickup">
                {exist ? (
                    <>
                        <PrimaryButton
                            btnSize="schedulePickupBtn mb-3"
                            onClick={manageCheckInModal}
                        >
                            <span className="material-icons-outlined mr-2">login</span>
                            Edit Check In
                        </PrimaryButton>
                    </>
                ) : (
                    <PrimaryButton btnSize="schedulePickupBtn mb-3" onClick={manageCheckInModal}>
                        <span className="material-icons-outlined mr-2">login</span>
                        Check In
                    </PrimaryButton>
                )}

                <CustomDialog
                    title={exist ? 'Edit Check In' : 'Check In'}
                    open={checkInModal}
                    function={() => {
                        manageCheckInModal()
                        setTrigger(!trigger)
                    }}
                    className="scheduleModal"
                    closeBtn={true}
                    maxWidth="md"
                >
                    <div className="scheduleModalCnt">
                        {checkInStep === 0 ? (
                            <div className="smDetails">
                                <div className="smMain">
                                    <form onSubmit={formikCheckIn.handleSubmit}>
                                        <div className="row">
                                            {Object.values(mapData(checkInInfo))}
                                            {formikCheckIn.values.type == 1 ? (
                                                <p>
                                                    Your items are ready. Please check in with our
                                                    customer service specialist. Thank you.
                                                </p>
                                            ) : null}
                                            <div className="col-12">
                                                <PrimaryButton
                                                    label={loading ? 'Loading...' : 'Check In'}
                                                    type="submit"
                                                    disabled={loading}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        ) : checkInStep === 1 ? (
                            <div className="smDate">
                                <div className="smMain booked text-center">
                                    <h4>Pickup Check {exist ? 'Edited' : 'Confirmed'}!</h4>
                                    <p>Your items are being prepared for a smooth collection.</p>
                                    <p>We&apos;ll notify you once everything is ready.</p>
                                    <p>Thank you for your patience!</p>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </CustomDialog>
                {global?.pluginConfiguration?.extended_pickup?.enable == 1 &&
                extendInvoices &&
                extendInvoices.length > 0 ? (
                    <Popup
                        open={openPickupExtension}
                        handleClose={() => {
                            !paymentLoading && setOpenPickupExtension(false)
                        }}
                        size="md"
                        className="save-search-modal"
                        modaltitle="Pickup Extension"
                    >
                        {
                            <>
                                <div className="extendCardGird">
                                    <div className="topInfoSec">
                                        <div>
                                            <h6>
                                                Invoice{' '}
                                                <span>
                                                    :{' '}
                                                    {extendInvoices.map((item) => item).join(', ')}
                                                </span>
                                            </h6>
                                            <h6>
                                                Amount{' (per invoice)'}
                                                <span>
                                                    :{' '}
                                                    {currencyFormat(
                                                        parseFloat(
                                                            global?.pluginConfiguration
                                                                ?.extended_pickup?.access_key,
                                                        ),
                                                        'usd',
                                                    )}
                                                </span>
                                            </h6>
                                        </div>

                                        <h6>
                                            Total Amount{' '}
                                            <span>
                                                :{' '}
                                                {currencyFormat(
                                                    parseFloat(
                                                        extendInvoices.length *
                                                            parseFloat(
                                                                global?.pluginConfiguration
                                                                    ?.extended_pickup?.access_key,
                                                            ),
                                                    ).toFixed(2),
                                                    'usd',
                                                )}
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="cardSecton">
                                        {allData &&
                                            allData.map((data, index) => (
                                                <div key={index} className="cardSelect 1233">
                                                    <label
                                                        htmlFor={`ritemb${index}`}
                                                        className="cardmain"
                                                    >
                                                        <div className="flx">
                                                            <p>
                                                                {global.storeConfigration
                                                                    ?.enable_cardknox?.value === '1'
                                                                    ? data.MaskedNumber
                                                                    : 'xxxx-xxxx-xxxx-' +
                                                                      data.last4}
                                                            </p>
                                                            <div className="radio-item">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`ritemb${index}`}
                                                                    name="ritem"
                                                                    value={data.id}
                                                                    checked={cardData === data.id}
                                                                    onChange={onChangeCard}
                                                                />
                                                                {/* <span className="vcRad"></span> */}
                                                            </div>
                                                        </div>
                                                        <div className="flx">
                                                            <p>{data.brand}</p>
                                                            <p>
                                                                {data.exp_month}/{data.exp_year}
                                                            </p>
                                                        </div>
                                                    </label>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                                <PrimaryButton
                                    label={paymentLoading ? 'Please wait...' : 'Pay'}
                                    className="w-auto"
                                    onClick={() => {
                                        handleExtendedPickupPayment()
                                    }}
                                    disabled={paymentLoading}
                                />
                            </>
                        }
                    </Popup>
                ) : null}
            </div>
            {global?.pluginConfiguration?.extended_pickup?.enable == 1 &&
            extendInvoices &&
            extendInvoices.length > 0 &&
            isHeader ? (
                <div className="ml-2">
                    <PrimaryButton
                        btnSize="schedulePickupBtn mb-3"
                        onClick={() => setOpenPickupExtension(true)}
                    >
                        <span className="material-icons-outlined mr-2">login</span>
                        Buy Pickup Extension ({extendInvoices.length})
                    </PrimaryButton>
                </div>
            ) : null}
        </>
    )
}

export default MultiCheckIn
